const assert = require('assert'),
  Long = require('long');

function toJSON({seconds = 0, nanos = 0}) {
  assert(Number.isInteger(seconds) || Long.isLong(seconds), 'seconds must be an integer number of instance of Long');
  assert(Number.isInteger(nanos), 'nanos must be an integer number');
  
  let nanosPortion = '';
  if (nanos !== 0) {
    nanosPortion = `.${nanos.toString().padStart(9, '0')}`;
  }
  return `${seconds}${nanosPortion}s`;
}

function fromJSON(string) {
  const [seconds, nanos] = string.substring(0, string.length - 1).split('.');
  
  return {seconds: Long.fromString(seconds), nanos: nanosForString(nanos)};
}

function nanosForString(nanos) {
  let res = 0;
  if (nanos !== undefined) {
    let precision = 3 - (nanos.length / 3);
    res = parseInt(nanos) * Math.pow(1000, precision);
  }
  return res;
}

module.exports = {toJSON, fromJSON};
